
export const CategoryInputs = [
    {
        label: 'Nome categoria',
        name: 'nome',
        placeholder: 'Nome categoria',
        type: 'text',
        validators: {
            required: 'Il nome è obbligatorio'
        },
        type_input: 'input',
        size_input: 'w-full',
    },
]